import { useState, type FormEvent } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { useToast } from '../context/ToastContext'
import { usePublicConfig } from '../context/PublicConfigContext'
import { Button } from '../components/ui/Button'
import { Input } from '../components/ui/Input'
import { ApiError } from '../api/client'

export function LoginPage() {
  const { login, authConfig, user } = useAuth()
  const { appName } = usePublicConfig()
  const navigate = useNavigate()
  const location = useLocation() as { state?: { from?: { pathname?: string } } }
  const toast = useToast()

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [submitting, setSubmitting] = useState(false)

  if (user) {
    const target = location.state?.from?.pathname || '/'
    navigate(target, { replace: true })
    return null
  }

  async function handleSubmit(e: FormEvent) {
    e.preventDefault()
    setSubmitting(true)
    try {
      await login(email, password)
      const target = location.state?.from?.pathname || '/'
      navigate(target, { replace: true })
    } catch (err) {
      toast.push(
        err instanceof ApiError && err.status === 401
          ? 'Ungültige Anmeldedaten'
          : 'Anmeldung fehlgeschlagen',
        'error',
      )
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <div className="auth-shell">
      <div className="auth-card">
        <h1 className="auth-title">Anmelden</h1>
        <p className="auth-sub">Willkommen zurück bei {appName}</p>

        {authConfig?.oidcEnabled ? (
          <Button
            variant="secondary"
            className="w-full"
            onClick={() => {
              window.location.href = '/api/auth/oidc/login'
            }}
          >
            Mit {authConfig.oidcProviderName} anmelden
          </Button>
        ) : null}

        {authConfig?.oidcEnabled && authConfig.localAuthEnabled ? (
          <div className="divider"><span>oder</span></div>
        ) : null}

        {authConfig?.localAuthEnabled ? (
          <form onSubmit={handleSubmit} className="stack">
            <Input
              type="email"
              name="email"
              label="E-Mail"
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <Input
              type="password"
              name="password"
              label="Passwort"
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <Button type="submit" loading={submitting} className="w-full">
              Anmelden
            </Button>
          </form>
        ) : null}

        {!authConfig?.localAuthEnabled && !authConfig?.oidcEnabled ? (
          <p className="muted">Keine Anmeldemethode aktiv. Bitte Admin kontaktieren.</p>
        ) : null}
      </div>
    </div>
  )
}
